import { useEffect, useRef } from "react"
import { toast } from "react-toastify";

interface Props {
  validator: boolean;
  message: string;
}

export const useLoadingNotification = ({ validator, message }: Props) => {
  const toastId = useRef<ReturnType<typeof toast.loading> | null>(null);

  useEffect(() => {
    if (validator) {
      toastId.current = toast.loading(message);
    } else if (toastId.current) {
      toast.dismiss(toastId.current);
      toastId.current = null;
    }
  }, [validator, message]);
}
